import { createFeatureSelector, MemoizedSelector, createSelector } from '@ngrx/store';
import { featureVisitorsKey } from '@fund-base/store/reducers/visitors.reducer';
import { VisitorsState } from '../state/visitors.state';
import { VisitorLimitsType } from '@fund-base/types/visitors/visitor-limits.types';

// store
const getIsLoading = (state: VisitorsState): boolean => state.loading;
const getLimits = (state: VisitorsState): VisitorLimitsType | undefined => state.limits;
const getExpireDate = (state: VisitorsState): Date | undefined => {
  if (!state.startDate) return undefined;
  const expiresDate = new Date(state.startDate);
  expiresDate.setDate(expiresDate.getDate() + state.limits.expiresInDays);
  return expiresDate;
};

// settings state
export const selectVisitorsState: MemoizedSelector<object, VisitorsState> =
  createFeatureSelector<VisitorsState>(featureVisitorsKey);

export const selectVisitorLoading: MemoizedSelector<object, boolean> = createSelector(
  selectVisitorsState,
  getIsLoading
);

export const selectVisitorLimits: MemoizedSelector<object, VisitorLimitsType | undefined> = createSelector(
  selectVisitorsState,
  getLimits
);

export const selectVisitorStartDate: MemoizedSelector<object, Date | undefined> = createSelector(
  selectVisitorsState,
  getExpireDate
);
